

/* @ngInject */ 
export default function AuthModal($rootScope, $templateCache) {
	var templateString = $templateCache.get('templates/auth-modal/auth-modal-tmpl.html');
	return {
		restrict: 'E',
		scope: {
			showModal: '=',
			closeModal: '=',
			canClose: '@'
		},
		template: templateString,
		transclude: {
			modalHeader: 'authModalHeader',
			modalBody: 'authModalBody'
		},
		link: AuthModalLink
	};

	function AuthModalLink(scope, element) {
		var $element = $($(element).get(0));
		var $modalBackground = $element.parent();

		scope.closeModal = function() {
			$modalBackground.slideUp('280');
			$rootScope.$broadcast('auth-modal-closed', $modalBackground);
		};

		scope.showModal = function() {
			$rootScope.$broadcast('auth-modal-shown', $modalBackground);
			if ($modalBackground.css('display') === 'none') {
				$modalBackground.animate(
					{
						height: 'toggle'
					},
					{
						duration: 600,
						specialEasing: {
							width: 'linear',
							height: 'easeInOutExpo' //"easeOutBack"//"easeOutQuart"
						}
						/*,
                                                    complete: function() {
                                                        setTimeout(function() {
                                                            $modalBackground.slideUp("280");
                                                        }, timeoutPeriod || 2000000);
                                                    }*/
					}
				);
			}
		};
	}
}
